export default "__VITE_ASSET__CDGSEYDL__"